import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Warning-Triangle--Streamline-Flex"
    >
        <desc>
            {'Warning Triangle Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="warning-triangle--frame-alert-warning-triangle-exclamation-caution">
            <path
                id="Vector 2482"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.540297 10.7318C1.77742 6.62853 4.62775 2.93528 6.3881 1.24866c0.34604 -0.331547 0.87776 -0.331547 1.2238 0 1.76035 1.68662 4.6107 5.37987 5.8478 9.48314 0.1302 0.4317 -0.0621 0.8914 -0.4742 1.0748C11.8024 12.3333 9.64575 13 7 13s-4.80236 -0.6667 -5.98554 -1.1934c-0.412068 -0.1834 -0.604323 -0.6431 -0.474163 -1.0748Z"
                strokeWidth={1}
            />
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 4.43555v3.43958"
                strokeWidth={1}
            />
            <path
                id="Vector 2494"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 9.63159v0.62061"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
